/*
 * File: /src/helpers/video-embed-helper.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Monday, 13th August 2018 9:25:20 am
 * Last Modified: Monday, 13th August 2018 12:45:29 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
const patterns = [
    {regex: /youtu\.be\/([\w\-.]+)/, type: 'youtube', url: '//www.youtube.com/embed/', pos: 1},
    {regex: /youtube\.com(.+)v=([^&]+)/, type: 'youtube', url: '//www.youtube.com/embed/', pos: 2},
    {regex: /vimeo\.com\/([0-9]+)/, type: 'vimeo', url: '//player.vimeo.com/video/', pos: 1},
    {regex: /vimeo\.com\/(.*)\/([0-9]+)/, type: 'vimeo', url: '//player.vimeo.com/video/', pos: 2},
]

const embedCode = '<iframe src="{url}" {iframeParams} frameborder="0"></iframe>'

const paramsReservedForIframe = ['width', 'height', 'allowFullScreen', 'customClass']

const iframeFullscreenParams = `webkitallowfullscreen mozallowfullscreen allowfullscreen `

const findPattern = ({ link }) => {
    for (let pattern of patterns) {
        if (match = link.match(pattern.regex)) {
            return { pattern, id: match[pattern.pos] }
        }
    }

    return { pattern: null, id: null }
}

const generateUrlFromPattern = ({ pattern, id, params }) => {
    let url = `${pattern.url}${id}`

    if (!params) {
        return url
    }

    // --> use ony params for query
    let _params = Object.assign({}, params)
    for (let keyString of paramsReservedForIframe) {
        delete _params[keyString]
    }

    let queryString = Object.keys(_params).map(key => key + '=' + _params[key]).join('&');
    
    return `${url}?${queryString}` 
}

const generateEmbedCode = ({ url, params, pattern }) => {
    params = params || {}

    let template = embedCode
    let iframeParams = ``

    // --> Use only params for iframe
    if (params.width) { iframeParams += `width="${params.width}" ` }
    if (params.height) { iframeParams += `height="${params.height}" ` }
    if (params.allowFullScreen) { iframeParams += iframeFullscreenParams}
    if (params.customClass) { iframeParams += `class="${params.customClass}" `}

    template = template.replace('{url}', url)
    template = template.replace('{iframeParams}', iframeParams)

    return template
}

exports.getEmbedCode = ({ link, params }) => {
    let { pattern, id } = findPattern({ link })

    if (!pattern) {
        return null
    }

    let url = generateUrlFromPattern({ pattern, id, params })
    let code = generateEmbedCode({ url, params, pattern })

    return code
}

exports.iframeFullscreenParams = iframeFullscreenParams


// WEBPACK FOOTER //
// ./src/helpers/video-embed-helper.js